export default __webpack_public_path__ + "media/images/apple-icon-144x144-e8b238c6.png";